module.exports = __webpack_public_path__ + "files/3b8dc8b20c0f5560b8f50989e0ba5f17.png";